/**
 * CustomToggles Style01 - Stitch v1: glass card, toggle icon, toggle buttons (eco / sleep / turbo)
 * 互動與狀態：state 來自 props（真實資料），點擊時先更新 local state（樂觀更新），再呼叫 onCommand
 */
import { useState, useEffect, useMemo } from 'react'
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import { resolveCustomTogglesFromAttributes } from './traitStyleConfig'
import { CUSTOM_TOGGLE_CONFIG } from '../traits/types'
import './CustomTogglesStyle01.css'

export function CustomTogglesStyle01({
  trait,
  state,
  attributes,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const { icon } = getTraitConfig(trait ?? 'CustomToggles')
  const toggleKeys = useMemo(() => resolveCustomTogglesFromAttributes(attributes), [attributes])
  const fromState = (state?.customToggles ?? {}) as Record<string, boolean>
  const [localOverrides, setLocalOverrides] = useState<Record<string, boolean>>({})

  useEffect(() => {
    setLocalOverrides({})
  }, [state?.customToggles])

  const toggleState = useMemo(
    () => ({ ...fromState, ...localOverrides }),
    [fromState, localOverrides]
  )

  const handleToggle = (key: string) => {
    if (disabled) return
    const next = !(toggleState[key] ?? false)
    setLocalOverrides((prev) => ({ ...prev, [key]: next }))
    void onCommand('setCustomToggle', { key, value: next })
  }

  return (
    <div className="trait-customtoggles-style01 trait-stitch-glass">
      <div className="trait-customtoggles-style01__header">
        <span className="trait-customtoggles-style01__title">CustomToggles</span>
        <span className={`material-symbols-outlined trait-customtoggles-style01__icon`}>{icon}</span>
      </div>
      <div className="trait-customtoggles-style01__grid">
        {toggleKeys.map((key) => {
          const config = CUSTOM_TOGGLE_CONFIG[key] ?? { label: { en: key }, icon: 'toggle_on' }
          const isActive = toggleState[key] ?? false
          const label = config?.label?.en ?? key
          return (
            <button
              key={key}
              type="button"
              className={`trait-customtoggles-style01__btn ${isActive ? 'active' : ''}`}
              onClick={() => handleToggle(key)}
              disabled={disabled}
            >
              <span className="material-symbols-outlined trait-customtoggles-style01__btn-icon">
                {config?.icon ?? 'toggle_on'}
              </span>
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
